import * as React from "react";
import {Student} from "Stores/commonStore";
import {Button, Col, Form, Nav, Row, Table} from "react-bootstrap";
import {ListSelector, SelectionItem} from "Components/Common/ListSelector";
import * as _ from "lodash";
import {StudentDataSource, StudentGroup, StudentStore} from "Stores/studentStore";
import {inject, observer} from "mobx-react";


interface StudentGroupFormProps {
    studentStore?: StudentStore
    onSubmit: (studentId: string, groups: string[]) => void
    onCancel: () => void
    student: Student
    groups: StudentGroup[]
    className?: string
}

interface StudentGroupFormState {
    studentGroupsOptions: SelectionItem[]
    dataSourceList: StudentDataSource[]
}

@inject("studentStore")
@observer
export class StudentForm extends React.Component<StudentGroupFormProps, StudentGroupFormState> {
    state = {
        studentGroupsOptions: [] as SelectionItem[],
        dataSourceList: [] as StudentDataSource[]
    };

    componentDidMount() {
        if (!this.props.studentStore) {
            return;
        }
        this.props.studentStore.fetchGroupsForStudent(this.props.student.ruuid).then((groups: StudentGroup[]) => {
            const allGroups = this.props.groups.map(group => {
                const found = groups.find(selectedGroup => selectedGroup.ruuid === group.ruuid);
                return {id: group.ruuid, content: group.name, isSelected: !!found};
            });

            this.setState({
                studentGroupsOptions: allGroups
            });
        });

        this.props.studentStore.fetchStudentDataSource(this.props.student.ruuid).then((dataSourceList: StudentDataSource[]) => {
            this.setState({
                dataSourceList
            });
        });
    }

    isValid = () => {
        return true;
    };

    handleSubmit = () => {
        const selectedGroups = this.state.studentGroupsOptions
            .filter((selection: SelectionItem) => selection.isSelected)
            .map((selection: SelectionItem) => (selection.id));

        this.props.onSubmit(this.props.student.ruuid, selectedGroups);
    };

    handleCancel = () => {
        this.props.onCancel();
    };

    handleSortingSelection = (items: SelectionItem[], selected: SelectionItem[]) => {
        _.forEach(items, (s: SelectionItem) => {
            s.isSelected = false;
        });
        _.forEach(selected, (s: SelectionItem) => {
            s.isSelected = true;
        });

        this.setState({ studentGroupsOptions: [...items, ...selected] });
    };

    renderDataSourceItem = (datasource: StudentDataSource) => {
        let dataSourceName = "";
        if (datasource.datasource === "ex") {
            dataSourceName = "ExamSoft";
        } else if (datasource.datasource === "ca") {
            dataSourceName = "Canvas";
        }

        return (
            <tr key={datasource.id}>
                <td>{dataSourceName}</td>
                <td>{datasource.source_id}</td>
            </tr>
        );
    };

    render() {
        return (
            <div className={this.props.className}>
                <Nav variant="underline" defaultActiveKey="editStudent">
                    <Nav.Item>
                        <Nav.Link eventKey="editStudent">Edit students</Nav.Link>
                    </Nav.Item>
                </Nav>
                <Form>
                    <div className="title-form-section">General</div>
                    <Row className="mb-3 form-section">
                        <Form.Group as={Col} controlId="formStudentFirstName">
                            <Form.Label>First Name</Form.Label>
                            <Form.Control type="text" placeholder="First Name" readOnly={true} value={this.props.student && this.props.student.first_name || ""} />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formStudentLastName">
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control type="text" placeholder="Last Name" readOnly={true} value={this.props.student && this.props.student.last_name || ""}/>
                        </Form.Group>

                        <Form.Group as={Col} controlId="formStudentEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="email" placeholder="Email" readOnly={true} value={this.props.student && this.props.student.student_email || ""}/>
                        </Form.Group>
                    </Row>
                    <Row>
                        <Col>
                            {this.props.studentStore && this.props.studentStore.isFetchingDataSource ?
                                <div>Loading</div>
                                : <Table striped bordered size="sm">
                                    <thead>
                                    <tr>
                                        <th>Datasource</th>
                                        <th>ID</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.dataSourceList.map(datasource => this.renderDataSourceItem(datasource))}
                                    </tbody>
                                </Table> }
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            {this.props.studentStore && this.props.studentStore.isProcessing ?
                                <div>Loading</div>
                                : <ListSelector
                                    items={this.state.studentGroupsOptions}
                                    dividerButton={true}
                                    handleSelectionChange={this.handleSortingSelection}
                                    reverse={true}
                                    studentsFormat
                                    />}

                        </Col>
                    </Row>
                    <Row className="student-close-box mb-3 pt-2">
                        <Col className="text-end button-group">
                            <Button
                                onClick={this.handleCancel}
                                variant="outline"
                                className="cancel"
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={this.handleSubmit}
                                disabled={!this.isValid()}
                                variant="secondary"
                            >
                                Save Changes
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}